import React, { useContext } from "react";
import S from "./BranchDistributions";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";
import Table from "../../../Table/index";
import moment from "moment";

const BranchDistributions: React.FC<FundSingle> = ({ short = false }) => {
  const {
    fundRiskDetails,
    getIndustryBySectorCode,
    getIndustryIconBySectorCode,
    outputPercentage,
  } = useContext(FundContext);

  if (!fundRiskDetails) return null;

  if (!fundRiskDetails.Portfolios[0]?.GlobalStockSectorBreakdown)
    return <h1>Missing data</h1>;

  var stockSectorBreakdown =
    fundRiskDetails.Portfolios[0]?.GlobalStockSectorBreakdown?.find(
      (item: any) => item.SalePosition === "N"
    )?.BreakdownValues;
  var CategoryStockSectorBreakdown =
    fundRiskDetails.Benchmark[0]?.Portfolios[0]?.GlobalStockSectorBreakdown?.find(
      (item: any) => item.SalePosition === "N"
    )?.BreakdownValues;
  var stockSectorBreakdownDate = moment(
    fundRiskDetails.Portfolios[0]?.Date
  ).format("YYYY-MM-DD");

  var tableValues = {};

  stockSectorBreakdown.sort((a: any, b: any) => b.Value - a.Value);

  stockSectorBreakdown.forEach((item: any) => {
    var breakdown = CategoryStockSectorBreakdown.find(
      (categoryItem: any) => categoryItem.Type === item.Type
    );
    var industryName = getIndustryBySectorCode(item.Type);
    var IndustryIcon = getIndustryIconBySectorCode(item.Type);
    var categoryValue = breakdown ? breakdown.Value : 0;

    tableValues[industryName] = [
      <>
        {IndustryIcon && (
          <div className={"sector-branch-icon sector-branch-icon-" + item.Type}>
            <IndustryIcon />
          </div>
        )}
        <span>{industryName}</span>
      </>,
      <span>{outputPercentage(item.Value)}</span>,
      <span>{outputPercentage(categoryValue)}</span>,
    ];
  });

  var tableData = {
    headings: ["BRANSCH", "FOND", "KATEGORI"],
    rows: tableValues,
  };

  return (
    <S.AllocationWrapper>
      <CardHeader
        title="Branschfördelning %"
        subTitle={stockSectorBreakdownDate}
      />
      <Table tableData={tableData} skipKey={true} />
    </S.AllocationWrapper>
  );
};

export default BranchDistributions;
